
const digest = '2f25d5df4309b2fe2f9e1f42a8dd1f85c20c30a11f4e224a44bf62caf320bb52';
const classes = {"wrapper":"_wrapper_4qfmo_1","pageTitle":"_pageTitle_4qfmo_12","main":"_main_4qfmo_16","domainBlock":"_domainBlock_4qfmo_21","header":"_header_4qfmo_33","title":"_title_4qfmo_39","address":"_address_4qfmo_57","copyButton":"_copyButton_4qfmo_73","hint":"_hint_4qfmo_94","speedButtons":"_speedButtons_4qfmo_98","speedButton":"_speedButton_4qfmo_98","iconWrapper":"_iconWrapper_4qfmo_117","text":"_text_4qfmo_127","subscriptionPayments":"_subscriptionPayments_4qfmo_134","right":"_right_4qfmo_161","nextPayment":"_nextPayment_4qfmo_166","faqsWrapper":"_faqsWrapper_4qfmo_170"};
const css = `._wrapper_4qfmo_1 {
  font-family: Rubik, sans-serif;
  height: 100%;
  overflow-y: auto;
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 30px;
  padding: 24px;
  border: 1px solid #eaedf3;
}
._wrapper_4qfmo_1 ._pageTitle_4qfmo_12 {
  font-size: 26px;
  font-weight: 700;
}
._wrapper_4qfmo_1 ._main_4qfmo_16 {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-gap: 20px;
}
._wrapper_4qfmo_1 ._main_4qfmo_16 ._domainBlock_4qfmo_21 {
  background: #ffffff;
  border-radius: 25px;
  padding: 40px;
  display: flex;
  flex-direction: column;
  gap: 30px;
  grid-column: span 2;
  --tw-shadow: 0 1px 2px 0 rgb(0 0 0 / 0.05);
  --tw-shadow-colored: 0 1px 2px 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 rgba(0, 0, 0, 0)), var(--tw-ring-shadow, 0 0 rgba(0, 0, 0, 0)), var(--tw-shadow);
}
._wrapper_4qfmo_1 ._main_4qfmo_16 ._domainBlock_4qfmo_21 ._header_4qfmo_33 {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
}
._wrapper_4qfmo_1 ._main_4qfmo_16 ._domainBlock_4qfmo_21 ._header_4qfmo_33 ._title_4qfmo_39 {
  display: flex;
  flex-direction: row;
  align-items: center;
  color: #94a3b8;
  font-weight: 600;
  font-size: 14px;
  gap: 5px;
  text-transform: uppercase;
}
._wrapper_4qfmo_1 ._main_4qfmo_16 ._domainBlock_4qfmo_21 ._header_4qfmo_33 ._title_4qfmo_39 img {
  height: 25px;
}
._wrapper_4qfmo_1 ._main_4qfmo_16 ._domainBlock_4qfmo_21 ._title_4qfmo_39 {
  font-size: 22px;
  font-weight: 500;
  margin-bottom: 10px;
}
._wrapper_4qfmo_1 ._main_4qfmo_16 ._domainBlock_4qfmo_21 ._address_4qfmo_57 {
  background: #f3f4f5;
  border-radius: 25px;
  color: #1d4ed8;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding: 12px 18px;
  font-size: 20px;
  font-weight: 500;
  align-items: center;
}
._wrapper_4qfmo_1 ._main_4qfmo_16 ._domainBlock_4qfmo_21 ._address_4qfmo_57 a {
  color: #1d4ed8;
  cursor: pointer;
}
._wrapper_4qfmo_1 ._main_4qfmo_16 ._domainBlock_4qfmo_21 ._address_4qfmo_57 ._copyButton_4qfmo_73 {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 5px;
  background: #ffffff;
  border-radius: 15px;
  border: 1px solid rgba(0, 84, 188, 0.2);
  font-weight: 600;
  width: fit-content;
  padding: 6px 12px;
  font-size: 14px;
  color: #0054bc;
  cursor: pointer;
}
._wrapper_4qfmo_1 ._main_4qfmo_16 ._domainBlock_4qfmo_21 ._address_4qfmo_57 ._copyButton_4qfmo_73 img {
  height: 16px;
}
._wrapper_4qfmo_1 ._main_4qfmo_16 ._domainBlock_4qfmo_21 ._address_4qfmo_57 ._copyButton_4qfmo_73:hover {
  background-color: #d9e2ff;
}
._wrapper_4qfmo_1 ._main_4qfmo_16 ._domainBlock_4qfmo_21 ._hint_4qfmo_94 {
  font-size: 14px;
  color: #94a3b8;
}
._wrapper_4qfmo_1 ._main_4qfmo_16 ._speedButtons_4qfmo_98 {
  display: flex;
  flex-direction: column;
  gap: 15px;
}
._wrapper_4qfmo_1 ._main_4qfmo_16 ._speedButtons_4qfmo_98 ._speedButton_4qfmo_98 {
  background: #ffffff;
  border-radius: 25px;
  padding: 20px;
  display: flex;
  flex-direction: row;
  gap: 10px;
  align-items: center;
  cursor: pointer;
  border: 1px solid #ffffff;
  --tw-shadow: 0 1px 2px 0 rgb(0 0 0 / 0.05);
  --tw-shadow-colored: 0 1px 2px 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 rgba(0, 0, 0, 0)), var(--tw-ring-shadow, 0 0 rgba(0, 0, 0, 0)), var(--tw-shadow);
}
._wrapper_4qfmo_1 ._main_4qfmo_16 ._speedButtons_4qfmo_98 ._speedButton_4qfmo_98 ._iconWrapper_4qfmo_117 {
  border-radius: 100%;
  height: 50px;
  width: 50px;
  padding: 10px;
  background: #d9e2ff;
}
._wrapper_4qfmo_1 ._main_4qfmo_16 ._speedButtons_4qfmo_98 ._speedButton_4qfmo_98 ._title_4qfmo_39 {
  font-weight: 600;
}
._wrapper_4qfmo_1 ._main_4qfmo_16 ._speedButtons_4qfmo_98 ._speedButton_4qfmo_98 ._text_4qfmo_127 {
  font-size: 12px;
}
._wrapper_4qfmo_1 ._main_4qfmo_16 ._speedButtons_4qfmo_98 ._speedButton_4qfmo_98:hover {
  border: 1px solid rgba(0, 84, 188, 0.2);
  background-color: #f3f5ff;
}
._wrapper_4qfmo_1 ._subscriptionPayments_4qfmo_134 {
  background: #ffffff;
  border-radius: 25px;
  --tw-shadow: 0 1px 2px 0 rgb(0 0 0 / 0.05);
  --tw-shadow-colored: 0 1px 2px 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 rgba(0, 0, 0, 0)), var(--tw-ring-shadow, 0 0 rgba(0, 0, 0, 0)), var(--tw-shadow);
  padding: 40px;
}
._wrapper_4qfmo_1 ._subscriptionPayments_4qfmo_134 ._header_4qfmo_33 {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin-bottom: 20px;
}
._wrapper_4qfmo_1 ._subscriptionPayments_4qfmo_134 ._header_4qfmo_33 ._title_4qfmo_39 {
  display: flex;
  flex-direction: row;
  align-items: center;
  color: #94a3b8;
  font-weight: 600;
  font-size: 14px;
  gap: 5px;
  text-transform: uppercase;
}
._wrapper_4qfmo_1 ._subscriptionPayments_4qfmo_134 ._header_4qfmo_33 ._title_4qfmo_39 img {
  height: 25px;
}
._wrapper_4qfmo_1 ._subscriptionPayments_4qfmo_134 ._header_4qfmo_33 ._right_4qfmo_161 {
  display: flex;
  flex-direction: row;
  gap: 30px;
}
._wrapper_4qfmo_1 ._subscriptionPayments_4qfmo_134 ._header_4qfmo_33 ._nextPayment_4qfmo_166 {
  font-size: 14px;
  color: #94a3b8;
}
._wrapper_4qfmo_1 ._faqsWrapper_4qfmo_170 {
  margin-top: 30px;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  